import { render, staticRenderFns } from "./ranking-chart.vue?vue&type=template&id=1d41f304&scoped=true&"
import script from "./ranking-chart.vue?vue&type=script&lang=js&"
export * from "./ranking-chart.vue?vue&type=script&lang=js&"
import style0 from "./ranking-chart.vue?vue&type=style&index=0&id=1d41f304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41f304",
  null
  
)

export default component.exports